import { API_PREFIX } from "../app/config";
import { client } from "@soniox/common-new";

export const getDashboardData = async () => {
  return client.authGet(`${API_PREFIX}dashboard/`);
};
